const formatEuro = value => new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
}).format(value / 100);

document.addEventListener('DOMContentLoaded', function() {
  
  document.querySelector('.filter-1').addEventListener('change', function() {
    const model = this.value;
    
    document.querySelectorAll('.filter-2 option').forEach(function(option) {
      option.setAttribute('hidden', 'true');
    });
    
    document.querySelectorAll('.filter-2 option').forEach(function(option) {
      if (option.getAttribute('model') == model) {
        option.removeAttribute('hidden');
      }
    });
  });

  document.querySelector('.find_product').addEventListener('click', function () {
    const container = document.querySelector('.filter-product-main');
    const resultArea = document.querySelector('.filter-product-result');
  
    container.classList.add('searching');
  
    const selectedOption = document.querySelector('.filter-2 option:checked');
    const productHandle = selectedOption ? selectedOption.getAttribute('product_handle') : null;
  
    if (!productHandle) {
      console.warn('No product handle found.');
      container.classList.remove('searching');
      return;
    }
  
    fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
    
        const saveAmount = product.compare_at_price > product.price
          ? `<span class="fpr-save">Sie sparen ${formatEuro(product.compare_at_price - product.price)}</span>`
          : '';
    
        const product_structure = `
          <div class="fpr-image"><img src="${product.featured_image}&width=460" /></div>
          <div class="fpr-content">
            <h2 class="fpr-title">${product.title}</h2>
            <div class="fpr-price">
              <span class="fpr-regular">${formatEuro(product.price)}</span>
              ${product.compare_at_price > product.price ? `<span class="fpr-compare_at_price">${formatEuro(product.compare_at_price)}</span>` : ''}
              ${saveAmount}
            </div>
            <a class="btn" href="${product.url}">Produkt anzeigen</a>
          </div>
        `;

        resultArea.innerHTML = product_structure;
        container.classList.remove('searching');
        container.classList.add('product_appear');
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        container.classList.remove('searching');
      });


  });
  


  const collectionHandle = document.querySelector('.product-finder-main')?.getAttribute('collection_data');
  const totalProductRaw = document.querySelector('.product-finder-main')?.getAttribute('total_product');
  const totalProduct = parseInt(totalProductRaw) || 0;
  const finalPage = Math.ceil(totalProduct / 24);
  const modelDropdown = document.getElementById('model-dropdown');
  const motorDropdown = document.getElementById('motor-dropdown');
  
  async function fetchCollectionHTML() {
    const fetchPromises = [];

    for (let i = 1; i <= finalPage; i++) {
      const url = `/collections/${collectionHandle}?page=${i}`;
      fetchPromises.push(
        fetch(url)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('.grid__item[model][motor]'));
          })
          .catch(err => {
            console.error(`Error loading page ${i}:`, err);
            return [];
          })
      );
    }

    const pages = await Promise.all(fetchPromises);
    return pages.flat(); // Merge all product elements into one array
  }

  fetchCollectionHTML().then(products => {
    const modelSet = new Set();
    const modelMotorMap = {};
    let firstModel = null;

    products.forEach(product => {
      const model = product.getAttribute('model');
      const motor = product.getAttribute('motor');
      const productHandle = product.getAttribute('product_handle') || product.getAttribute('data-handle') || '';

      if (!model || !motor) return;

      if (!firstModel) firstModel = model;

      if (!modelSet.has(model)) {
        modelSet.add(model);
      }

      if (!modelMotorMap[model]) modelMotorMap[model] = [];
      modelMotorMap[model].push({ motor, productHandle });
    });

    // Modelle alphabetisch sortieren
    const sortedModels = Array.from(modelSet).sort();
    sortedModels.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      modelDropdown.appendChild(opt);
    });


    // Initialize motor dropdown with first model's options
    if (firstModel && modelMotorMap[firstModel]) {
      motorDropdown.innerHTML = '';
      modelMotorMap[firstModel].forEach(({ motor, productHandle }) => {
        const opt = document.createElement('option');
        opt.value = motor;
        opt.textContent = motor;
        opt.setAttribute('model', firstModel);
        opt.setAttribute('motor', motor);
        opt.setAttribute('product_handle', productHandle);
        motorDropdown.appendChild(opt);
      });
    }

    // On model change → update motor dropdown
    modelDropdown.addEventListener('change', e => {
      const selectedModel = e.target.value;
      motorDropdown.innerHTML = '';

      if (modelMotorMap[selectedModel]) {
        modelMotorMap[selectedModel].forEach(({ motor, productHandle }) => {
          const opt = document.createElement('option');
          opt.value = motor;
          opt.textContent = motor;
          opt.setAttribute('model', selectedModel);
          opt.setAttribute('motor', motor);
          opt.setAttribute('product_handle', productHandle);
          motorDropdown.appendChild(opt);
        });
      }
    });
  });

});